module.exports = __webpack_public_path__ + "img/6.46f7f0d5.jpg";